import React, { Fragment, useContext } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { AuthContext } from '../../context/authContext';

import AuthHeader from '../../container/Layout/AuthHeader';
import FormInput from '../../components/form/input';
import FormButton from '../../components/form/button';
import AuthFooter from '../../container/Layout/AuthFooter';

import 'react-toastify/dist/ReactToastify.css';

const ForgotPassSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is Required')
});

const ForgotPassword = () => {
  document.title = 'CrowdFarmer | Forgot Password';

  const { forgotPassword, isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated()) return <Redirect to={'/home'} />;

  return (
    <Fragment>
      <AuthHeader />
      <div className="forgot-password">
        <div className="md:relative container mx-auto pt-16 px-4 md:px-0">
          <div className="w-full text-center mt-10">
            <h2 className="text-gray-200">Plant Food. Harvest Happiness.</h2>
          </div>

          <div className="w-full md:w-1/2 md:px-20 mx-auto text-center text-gray-200 leading-tight">
            <p className="text-sm md:text-base">
              I think having land and not ruining it is the most beautiful art that anybody could
              ever want to own.
            </p>
            <p className="text-sm">- Andy Warhol</p>
          </div>

          <div className="relative mx-auto lg:mx-0 lg:ml-auto bg-white rounded py-6 px-10 w-80 md:w-115 lg:mt-12 mt-32 md:mt-20 shadow-cfw md:shadow-none">
            <div className="text-center">
              <h3 className="font-header text-xl">Forgot Password</h3>
              <small>
                Don’t have a Complete Farmer account?{' '}
                <Link className="text-cf-300" to="/register">
                  Sign up here
                </Link>
              </small>
            </div>

            <Formik
              initialValues={{
                email: ''
              }}
              validationSchema={ForgotPassSchema}
              onSubmit={(values, { setSubmitting }) => {
                (async () => {
                  try {
                    setSubmitting(true);
                    const response = await forgotPassword(values);
                    setSubmitting(false);
                    if (response.code === 200) {
                      toast.success(response.message, {
                        position: toast.POSITION.TOP_RIGHT
                      });
                    } else {
                      throw response.data.message;
                    }
                  } catch (error) {
                    let errMgs = error;
                    if (typeof error !== 'string') {
                      errMgs = 'Unexpected server error';
                    }
                    toast.error(errMgs, {
                      position: toast.POSITION.TOP_RIGHT
                    });
                  }
                })();
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
              }) => (
                <Fragment>
                  <form className="flex flex-wrap mt-10" onSubmit={handleSubmit}>
                    <FormInput
                      error={errors.email}
                      touched={touched.email}
                      className="w-full"
                      change={handleChange}
                      blur={handleBlur}
                      inputValue={values.email}
                      type="email"
                      id="email"
                      placeholder="johndoe@example.com"
                      title="Email"
                      inputType
                    />

                    <FormButton
                      loading={isSubmitting}
                      name="Submit"
                      className="w-full"
                      color="bg-cf-300"
                      btnPad="px-4 py-3 my-3"
                    />
                  </form>
                </Fragment>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <AuthFooter />
    </Fragment>
  );
};

export default ForgotPassword;
